import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'app/store';
import EditHolidayGeneralForm from 'components/timeOff/EditHolidayGeneralForm';
import Preloader from 'components/shared/Preloader';
import { IHolidayInfoUpdatingData } from 'features/holidayInfo/holidayInfoTypes';
import { changeHolidayInfo } from 'features/holidayInfo/holidayInfoActions';
import {
  holidayInfoSelector,
  isLoadingHolidayInfoSelector,
} from 'features/holidayInfo/holidayInfoSlice';

const EditHolidayGeneral = () => {
  const isLoading = useSelector(isLoadingHolidayInfoSelector);
  const holiday = useSelector(holidayInfoSelector);
  const dispatch = useAppDispatch();

  const handleSubmit = (data: IHolidayInfoUpdatingData) => {
    dispatch(changeHolidayInfo(data));
  };

  return isLoading ? (
    <Preloader />
  ) : (
    <EditHolidayGeneralForm holiday={holiday} onSubmit={handleSubmit} />
  );
};

export default EditHolidayGeneral;
